export var navigationItemTheme = {
  baseStyle: _ref => {
    var {
      isMobile
    } = _ref;
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingX: isMobile ? 'none' : 'xs',
      paddingY: isMobile ? 's' : 'none',
      width: isMobile ? '100%' : '72px',
      height: '56px',
      cursor: 'pointer',
      color: 'neutral.darker',
      transition: 'color 0.1s',
      _hover: {
        color: 'neutral.darkest'
      },
      _focus: {
        borderRadius: 'l',
        outlineWidth: '2px',
        outlineColor: 'focus.focus'
      },
      _active: {
        color: 'brand.main'
      }
    };
  }
};
//# sourceMappingURL=NavigationItem.theme.js.map